import React from 'react'
import PageHeader from '../components/PageHeader'

function BestPractices() {
  return (
    <div>
      <PageHeader title="Best Practices"/>
    </div>
  )
}

export default BestPractices
